import { styled } from '@mui/material'
import InputAmount, { StyledInputAmountLarge } from 'components/InputAmount'
import { formatUnits } from 'ethers/lib/utils'
import { memo, useCallback, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { useCurrentNetwork } from 'store/app/hooks'
import { updateDepositAmountAction } from 'store/deposit/actions'
import { useDepositAmount, useDepositToken } from 'store/deposit/hook'
import { Ether } from 'types'
import { useEvmTokenBalance } from '../../store/web3/hooks'
import { useEthereumTokenInfo } from '../../hooks/web3/useEthereumTokenInfo'
import { StyledControlInputLarge } from '../../styles/Control'

export const Max = styled('div')`
  height: 24px;
  font-size: 14px;
  line-height: 24px;
  color: ${(props) => props.theme.color.text100};
  padding: 0 12px;
  cursor: pointer;
  border: 1px solid rgba(46, 54, 59, 1);
  border-radius: 12px;
  transition: all 0.2s ease-in-out;

  &:hover {
    color: rgba(160, 238, 9, 1);
    border-color: rgba(160, 238, 9, 1);
  }
`
const AmountControl = styled(StyledControlInputLarge)`
  gap: 8px;
`
const Symbol = styled('span')`
  font-size: 14px;
  font-weight: 600;
`

export const DepositAmount = memo(() => {
  const dispatch = useDispatch()
  const { layerOneChainId } = useCurrentNetwork()
  const amount = useDepositAmount()
  const { l2CurrencyId = 0, name = '' } = useDepositToken() ?? {}
  const { decimals = 0 } =
    useEthereumTokenInfo(layerOneChainId, l2CurrencyId) ?? {}
  const balance = useEvmTokenBalance(layerOneChainId, l2CurrencyId)

  const available = useMemo(() => {
    if (!balance || !decimals) {
      return '0'
    }
    return formatUnits(balance, decimals)
  }, [balance, decimals])

  const onInputAmount = useCallback((amount: Ether) => {
    dispatch(updateDepositAmountAction(amount))
  }, [])

  return (
    <AmountControl>
      <InputAmount
        as={StyledInputAmountLarge}
        value={amount}
        placeholder={`Enter amount...`}
        onInput={onInputAmount}
      />
      <div className="input-border" />
      <Max
        onClick={() => {
          dispatch(updateDepositAmountAction(available))
        }}
      >
        MAX
      </Max>
      {name && <Symbol>{name}</Symbol>}
    </AmountControl>
  )
})
